import { render, staticRenderFns } from "./exportExcelFacturePdf.vue?vue&type=template&id=2879c6b8&scoped=true&"
import script from "./exportExcelFacturePdf.vue?vue&type=script&lang=js&"
export * from "./exportExcelFacturePdf.vue?vue&type=script&lang=js&"
import style0 from "./exportExcelFacturePdf.vue?vue&type=style&index=0&id=2879c6b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2879c6b8",
  null
  
)

export default component.exports